import request from '@/utils/anjishengRequest'
import adminRequest from '@/utils/request'
import {formatDate,getPreMonth}  from '@/utils/date.js'


export function getDayEntityHourData(EntityID,BeginTime,EndTime) {
  
    var today =   formatDate(new Date(),"yyyy-MM-dd");
    if(!BeginTime)
         BeginTime = today+" "+"00:00:00";
    if(!EndTime)
        EndTime = today+" "+"23:59:59";
     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 1,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }
       return  getDataTotalEntity(data);      
}


export function getDayEntityData(EntityID,BeginTime,EndTime) {
  
    var today =   formatDate(new Date(),"yyyy-MM-dd");
    if(!BeginTime)
       BeginTime = today+" "+"00:00:00";
    if(!EndTime)
        EndTime = today+" "+"23:59:59";

     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 2,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }


       return  getDataTotalEntity(data);      
}

export function getEntityWeekData(EntityID,BeginTime,EndTime) {
  
    var today =   formatDate(new Date(),"yyyy-MM-dd");
    var weekDay = formatDate(new Date(new Date().getTime()-7*24*60*60*1000),"yyyy-MM-dd");
    if(!BeginTime)
       BeginTime = weekDay+" "+"00:00:00";
    if(!EndTime)   
       EndTime = today+" "+"23:59:59"

     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 3,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }
       return  getDataTotalEntity(data);      
}


export function getEntityMonthData(EntityID,BeginTime,EndTime) {
  
    var month =   formatDate(new Date(),"yyyy-MM");


    if(!BeginTime)
       BeginTime = month+"-01 "+"00:00:00";
    if(!EndTime)
       EndTime = month+"-"+ getMonthEndDay()+" 23:59:59";




     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 4,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }
    return  getDataTotalEntity(data);      
}

// 上个月
export function getLowEntityMonthData(EntityID,BeginTime,EndTime) {
  
   var year =   formatDate(new Date(),"yyyy");
   var month =   formatDate(new Date(),"MM");


   var beginmonth = (month*1-1);
   if(beginmonth<=0){
      beginmonth="01";
   }
   if (beginmonth<10) {
      beginmonth = "0" + beginmonth;
   }
   if(!BeginTime)
      BeginTime = year + "-" + beginmonth+"" +"-01 "+"00:00:00";
   if(!EndTime)
      EndTime = year + "-" + beginmonth+"-"+ getMonthEndDay(beginmonth)+" 23:59:59";

    var data = {
           "BeginTime": BeginTime,//开始时间，精确到秒 
           "EndTime": EndTime,//结束时间，精确到秒
           "TotalType": 2,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
           "EntityID": EntityID // 实体编号
    }

   return  getDataTotalEntity(data);   
}


export function getEntityMonth3Data(EntityID,BeginTime,EndTime) {
  
   var year =   formatDate(new Date(),"yyyy");
   var month =   formatDate(new Date(),"MM");
   var beginmonth = (month*1 - 2);
   if(beginmonth<=0){
      beginmonth="01";
   }
   if(!BeginTime)
      BeginTime = year + "-" + beginmonth+"" +"-01 "+"00:00:00";
   if(!EndTime)
      EndTime = year + "-" + month+"-"+ getMonthEndDay()+" 23:59:59";

    var data = {
           "BeginTime": BeginTime,//开始时间，精确到秒 
           "EndTime": EndTime,//结束时间，精确到秒
           "TotalType": 4,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
           "EntityID": EntityID // 实体编号
    }
   return  getDataTotalEntity(data);      
}


export function getEntityQuarterData(EntityID,BeginTime,EndTime) {
  
    var year =   formatDate(new Date(),"yyyy");
    if(!BeginTime)
       BeginTime = year+"-01-01 "+"00:00:00";
    if(!EndTime)  
       EndTime = formatDate(new Date(),"yyyy-MM-dd hh:mm:ss");

     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 5,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }
    return  getDataTotalEntity(data);      
}


export function getEntityYearData(EntityID,BeginTime,EndTime) {
  
    var year =   formatDate(new Date(),"yyyy");
    if(!BeginTime)
       BeginTime = year+"-01-01 "+"00:00:00";
    if(!EndTime)  
        EndTime = year+"-12-31 "+"23:59:59";

     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 6,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }
    return  getDataTotalEntity(data);      
}


export function getEntityAllYearData(EntityID,BeginTime,EndTime) {
  
    var year =   formatDate(new Date(),"yyyy");
    var beginYear = formatDate(new Date(new Date().getTime()-100*365*24*60*60*1000),"yyyy");
    if(!BeginTime)
       BeginTime = beginYear+"-01-01 "+"00:00:00"
    if(!EndTime)  
       EndTime = year+"-12-31 "+"23:59:59"

     var data = {
            "BeginTime": BeginTime,//开始时间，精确到秒 
            "EndTime": EndTime,//结束时间，精确到秒
            "TotalType": 6,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
            "EntityID": EntityID // 实体编号
     }
    return  getDataTotalEntity(data);      
}


export function getDataTotalEntity(data) {
    
    var headerInfo = JSON.parse(sessionStorage.getItem("headerInfo"));
    var baseUrl = headerInfo.ajsUrl;
    console.log('baseUrl',baseUrl)

        // {
        //     "BeginTime": "2021-07-10 18:52:19",//开始时间，精确到秒 
        //     "EndTime": "2021-07-10 18:52:19",//结束时间，精确到秒
        //     "TotalType": 0,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
        //     "EntityID": "3fa85f64-5717-4562-b3fc-2c963f66afa6" //实体编号
        //   }
        //   ```
        
        //   返回值：
        
        //   ```json
        //   "Data": [
        //       {
        //         "Name": "string", //指标名称
        //         "DataIn": 0, //进人数
        //         "DataOut": 0,//出人数
        //         "SideIn": 0,//外围进人数
        //         "SideOut": 0//外围出人数
        //       }
        //     ]
        //   var headerInfo = JSON.parse(sessionStorage.getItem("headerInfo"));
        //   var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));

        //     headerInfo.ajsUrl;
        //     headerInfo.sign;
        //     headerInfo.timestamp;
        //     libraryInfo.entityId;

         var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
         if( '1'==libraryInfo.interfaceType){
            // 直接调安吉生
               return request({
                  url: baseUrl+'openapi/FlowData/GetDataTotalEntity',
                  method: 'post',
                  data:data
               })
         }else{
              data.LibraryId = libraryInfo.id;
            // 本服务器调用：
               return adminRequest({
                  url: '/app/ajs/getEntityDataByTime',
                  method: 'post',
                  data:data
               })
         }
    
  }




// 天总进馆人数
  export function getCategoryEntityData(EntityID) {
  
   var today =   formatDate(new Date(),"yyyy-MM-dd");
   
    var data = {
           "BeginTime": today,//开始时间
           "EndTime": today,//结束时间
           "TotalType": 2,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
           "EntityID":EntityID //实体编号
    }
      return  getCategoryDataTotalEntity(data);      
}

// 年总进馆人数
export function getCategoryEntityYearData(EntityID) {
  
   var year =   formatDate(new Date(),"yyyy");
   var BeginTime = year+"-01-01 ";
   var EndTime = year+"-12-31 ";
   

    var data = {
           "BeginTime": BeginTime,//开始时间
           "EndTime": EndTime,//结束时间
           "TotalType": 6,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
           "EntityID":EntityID //实体编号
    }
   return  getCategoryDataTotalEntity(data);      
}

// 历史进馆人数
export function getCategoryEntityAllYearData(EntityID,BeginTime,EndTime) {
  
   var year =   formatDate(new Date(),"yyyy");
   var beginYear = formatDate(new Date(new Date().getTime()-100*365*24*60*60*1000),"yyyy");
   var BeginTime = beginYear+"-01-01 ";
   var EndTime = year+"-12-31 ";


    var data = {
           "BeginTime": BeginTime,//开始时间，精确到秒 
           "EndTime": EndTime,//结束时间，精确到秒
           "TotalType": 6,//汇总方式，1、按小时，2、按天，3、按周，4、按月，5、按季度，6、按年
           "EntityID":EntityID //实体编号
    }
   return  getCategoryDataTotalEntity(data);      
}


  export function getCategoryDataTotalEntity(data) {
    
   var headerInfo = JSON.parse(sessionStorage.getItem("headerInfo"));
   var baseUrl = headerInfo.ajsUrl;
   console.log('baseUrl',baseUrl)

   var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
   if( '1'==libraryInfo.interfaceType){
      // 直接调安吉生
         return request({
         url: baseUrl+'openapi/FlowData/GetCategoryDataTotal',
         method: 'post',
         data:data
         })
   }else{
      data.LibraryId = libraryInfo.id;
      return adminRequest({
         url: '/app/ajs/getCategoryDataTotal',
         method: 'post',
         data:data
       })
   }
 
 }

 export function getMonthEndDay(beginmonth){
   var year =   formatDate(new Date(),"yyyy");
   var month ;
   if(beginmonth){
      month = beginmonth;
   }else{
      month =   formatDate(new Date(),"MM");
   }
   var day31=['1','3','5','7','8','10','12','01','03','05','07','08']
   var day30=['4','6','9','11','04','06','09']
   if(month==2){
      if( year%4==0&&year%100!=0){
         return 29;
      }else{
         return 27;
      }
   }
   if(day31.indexOf(month)!=-1){
     return 31;
   }else if(day30.indexOf(month)!=-1){
      return 30;
   }else{
      return 30;
   }

}






// WEBPACK FOOTER //
// ./src/api/anjisheng.js